import { FormControl, FormHelperText, FormLabel, Stack } from '@mui/material';
import React from 'react';
import UserNotification from './UserNotification';
import NotificationEmailAutocomplete from './NotificationAutocomplete';

const AssigneeNotification = ({ type, label }) => {
	return (
		<Stack spacing={2}>
			<FormControl>
				<FormLabel variant='body2'>{`${label}s`}</FormLabel>
				<UserNotification type={type} action={'assigned'} />
			</FormControl>

			{/* <FormControl>
				<FormLabel
					sx={{
						color: 'rgba(0, 0, 0, 0.6)',
						fontWeight: 400,
						fontSize: '0.75rem',
					}}
				>
					{'Other emails'}
				</FormLabel>
				<NotificationEmailAutocomplete
					type={type}
					action={'complete'}
					id={`${type}-emails`}
				/>
				<FormHelperText>{`These email addresses will receive an email when a ${type} is completed`}</FormHelperText>
			</FormControl> */}
		</Stack>
	);
};

export default AssigneeNotification;
